export default __webpack_public_path__ + "static/media/logo-spotify.e83cf56c.svg";